// Libraries
import TomSelect from "tom-select";
import Isotope from "isotope-layout";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Style
import "./style.scss";

// Scripts
import initEmployerAuth from "./js/employer-auth";

// Extract Background Colour from Gutenberg Classes
function bonesthemeExtractColour(node) {
  const colReg = /has-(.[^\s]*)-background-color/i;
  const classes = node.classList.toString();
  const matches = classes.match(colReg);

  if (matches !== null) {
    return matches[1];
  } else {
    const colRegGrad = /has-(.[^\s]*)-gradient-background/i;
    const matchesGrad = classes.match(colRegGrad);
    if (matchesGrad !== null) {
      return matchesGrad[1];
    }
  }

  return "";
}

document.addEventListener("DOMContentLoaded", () => {
  // Initialize Employer Auth
  initEmployerAuth();

  // Sid Replace

  if (document.querySelectorAll('a[href*="{{params}}"]').length > 0) {
    // Generate the parameters
    let params = [];

    // Theme
    const validThemes = [
      "gambling",
      "drugs",
      "alcohol",
      "relationship-concerns",
      "anger",
      "all",
    ];
    let theme = "all"; // Default
    if (localStorage.getItem("question-2-answer")) {
      // Ensure a valid response
      theme =
        validThemes.indexOf(localStorage.getItem("question-2-answer")) >= 0
          ? localStorage.getItem("question-2-answer")
          : "all";
    }
    // else {
    // Override if on one of these pages
    const themesPages = {
      gambling: "gambling",
      drugs: "drugs",
      alcohol: "alcohol",
      emotions: "anger",
      "relationship-concerns": "relationship-concerns",
    };

    // Check if someone is clicking from a theme page
    for (const pageClass in themesPages) {
      if (document.body.classList.contains("page-" + pageClass)) {
        theme = themesPages[pageClass];
      }
    }
    // validThemes.forEach( ( themeLabel ) => {
    // 	if( document.body.classList.contains( 'page-' + themeLabel ) ) {
    // 		theme = themeLabel;
    // 	}
    // } );
    // }
    params.push("theme=" + theme);

    // Session
    let session = "initialConsultation"; // Default
    // if( localStorage.getItem( 'question-1-answer' ) ) {
    // 	const validSessions = [ 'initialConsultation', 'supportedAdvice' ];
    // 	// Ensure a valid response
    // 	session = ( validSessions.indexOf( localStorage.getItem( 'question-1-answer' ) ) >= 0 ) ?
    // 		localStorage.getItem( 'question-1-answer' ) : 'initialConsultation';
    // }
    params.push("session=" + session);

    // Append SID
    if (document.querySelector('meta[name="sid"]')) {
      const sid =
        document.querySelector('meta[name="sid"]')?.attributes.content.value;
      params.push("sid=" + sid);
    }

    // Apply to each link
    document.querySelectorAll('a[href*="{{params}}"]').forEach((link) => {
      link.href = link.href.replace(/{{params}}/i, params.join("&"));
    });
  }

  // document.querySelectorAll( 'a[href*="{{sid}}"]' ).forEach( ( link ) => {
  // 	if( document.querySelector( 'meta[name="sid"]' ) ) {
  // 		const sid = document.querySelector( 'meta[name="sid"]' )?.attributes.content.value;
  // 		link.href = link.href.replace( /{{sid}}/i, sid );
  // 	}
  // } );

  // Navgation Appearance
  document
    .querySelectorAll(
      ".menu-toggle > .hamburger, .overlay-close .wp-block-button__link"
    )
    .forEach((item) => {
      item.addEventListener("click", (e) => {
        const isActive = document.body.classList.toggle("toggle-navigation");
        document
          .querySelector(".menu-toggle .hamburger")
          ?.classList.toggle("is-active", isActive);
      });
    });

  // iOS window height work around
  window.addEventListener("resize", bones_theme_window_height);
  bones_theme_window_height();

  // Style form selects
  document.querySelectorAll(".wp-site-blocks select").forEach((select) => {
    new TomSelect(select, {
      allowEmptyOption: true,
      create: true,
      // hidePlaceholder: false
    });
  });

  // Nav Appearance on Scroll
  // if( document.querySelector( '.page-template-page-home-landing' ) == null ) {
  // console.log( 'working' );
  const header = document.querySelector("header.wp-block-template-part");
  if (header) {
    const start = 20; // header.offsetHeight - 1;
    gsap.timeline({
      scrollTrigger: {
        trigger: "main",
        start: start + "px start",
        // end: "bottom bottom",
        scrub: 1,
        toggleClass: { targets: header, className: "show-shadow" },
        // markers: true
      },
    });
  }
  // }

  // Nav Apperance before Scroll
  if (document.querySelector("main > .wp-block-post-content > *:first-child")) {
    const firstBlock = document.querySelector(
      "main > .wp-block-post-content > *:first-child"
    );
    // Get colour from Gutenberg classes
    const backgroundColour = bonesthemeExtractColour(firstBlock);
    if (backgroundColour != "") {
      document.body.classList.add("logo-fill-background-" + backgroundColour);
    }
  }

  // Logo Fill Colour
  // ScrollTrigger.matchMedia( {
  // 	"(max-width: 767px)": function() {

  // 	},
  // "(min-width: 768px)": function() {
  // 	document.querySelectorAll( '.wp-block-post-content > .has-background' ).forEach( ( block ) => {
  // 		const colReg = /has-(.[^\s]*)-background-color/i;
  // 		const classes = block.classList.toString();
  // 		const matches = classes.match( colReg );
  // 		let backgroundColour = '';
  // 		if( matches !== null ) {
  // 			backgroundColour = matches[1];
  // 		}
  // 		else {
  // 			const colRegGrad = /has-(.[^\s]*)-gradient-background/i;
  // 			const matchesGrad = classes.match( colRegGrad );
  // 			if( matchesGrad !== null ) {
  // 				backgroundColour = matchesGrad[1];
  // 			}
  // 		}

  // 		if( backgroundColour !== '' ) {
  // 			gsap.timeline( {
  // 				scrollTrigger: {
  // 					trigger: block,
  // 					start: "start start+=1",
  // 					end: "bottom-=75 start",
  // 					scrub: 1,
  // 					toggleClass: { targets: document.body, className: 'logo-fill-background-' + backgroundColour },
  // 					// once: true,
  // 					// markers: true,
  // 				}
  // 			} );
  // 		}
  // 	} );
  // }
  // } );

  // Questions
  document.querySelectorAll(".wp-block-questions a").forEach((link) => {
    link.addEventListener("click", (e) => {
      if (link.getAttribute("href") !== "#") {
        return;
      }

      e.preventDefault();

      // Current Question
      const question = link.closest(".questions");
      const wrapper = link.closest(".questions-wrapper");

      const i = parseInt(question.dataset.questionSet) + 1;
      const label = question.dataset.questionLabel;
      const answer = e.target.dataset.answer;

      // Store questions and answer for later user
      localStorage.setItem("question-" + i + "-label", label);
      localStorage.setItem("question-" + i + "-answer", answer);

      // Show Next Question
      question.classList.remove("is-visible-question");
      if (question.nextSibling !== null) {
        question.nextSibling.classList.add("is-visible-question");
        wrapper.classList.add("highlight");
      } else {
        document.querySelector(".questions-title")?.classList.add("is-hidden");

        if (
          localStorage.getItem("question-1-answer") == "initialConsultation"
        ) {
          // For themselves
          if (e.target.dataset["redirect"]) {
            window.location = e.target.dataset["redirect"];
          }
        } else {
          if (e.target.dataset["redirectOthers"]) {
            window.location = e.target.dataset["redirectOthers"];
          }
        }
      }
    });
  });
});

// iOS window height
const bones_theme_window_height = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);

  if (document.querySelector("header")) {
    doc.style.setProperty(
      "--app-header-height",
      `${document.querySelector("header").offsetHeight}px`
    );
  }
};

window.addEventListener("load", () => {
  // Landing Splash
  if (document.querySelector("body.page-home")) {
    // Check if has been loaded before
    if (localStorage.getItem("helm-splash-loaded")) {
      // Do nothing other than loading the normal page
      document.querySelector(".wp-site-blocks")?.classList.add("is-visible");
    } else {
      if (document.querySelector(".wp-block-template-part.overlay-splash")) {
        // Show Spash
        document
          .querySelector(".wp-block-template-part.overlay-splash")
          .classList.add("is-visible");

        // Load page behind
        setTimeout(() => {
          document
            .querySelector(".wp-site-blocks")
            ?.classList.add("is-visible");
        }, 500);

        // Hide after two seconds
        setTimeout(() => {
          document
            .querySelector(".wp-block-template-part.overlay-splash")
            .classList.remove("is-visible");
        }, 4000);
      } else {
        // Make visible if something has gone wrong
        document.querySelector(".wp-site-blocks")?.classList.add("is-visible");
      }
      // Set localStorage marker
      localStorage.setItem("helm-splash-loaded", true);
    }
  }

  if (document.querySelector(".counsellor-popup")) {
    var popup = document.querySelector(".counsellor-popup");
    var icon = document.querySelector(".close-icon");

    // Show popup after a delay
    function showPopup() {
      popup.classList.add("show-popup");
    }
    setTimeout(showPopup, 3000);

    // Hide popup on click (counsellors page)
    function hidePopup() {
      popup.classList.remove("show-popup");
    }
    icon.addEventListener("click", hidePopup);
  }
});

//Functionality for Quiz
var quizRow = document.querySelectorAll(".quiz-row div");
var qRows = document.querySelectorAll(".quiz-row");
var resultsBtn = document.querySelector(".btn-results");

//Disable link on result button
if (resultsBtn && resultsBtn.classList.contains("disabled")) {
  resultsBtn.addEventListener("click", function (e) {
    if (resultsBtn.classList.contains("disabled")) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

var activeCount = 0;
var resultLink = {
  stopUpdating: false,
  linkURL: "",
};

//Equal height columns for quiz questions
function equalHeightQuestions() {
  if (qRows.length > 0) {
    for (var i = 0; i < qRows.length; i++) {
      var height = qRows[i].offsetHeight;
      var question = qRows[i].getElementsByClassName("quiz-question");
      if (question.length > 0) {
        for (var j = 0; j < question.length; j++) {
          question[j].style.height = `${height}px`;
        }
      }
    }
  }
}
equalHeightQuestions();

window.onresize = equalHeightQuestions;

if (quizRow.length > 0) {
  for (var i = 0; i < quizRow.length; i++) {
    //Disable link on quiz options
    var link = quizRow[i].getElementsByTagName("a");
    if (link.length) {
      link[0].addEventListener("click", function (e) {
        e.preventDefault();
      });
    }

    //add event listener to activate quiz options
    quizRow[i].addEventListener("click", function () {
      var parent = this.parentNode;
      var children = parent.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.classList.contains("active")) {
          activeCount--;
        }
        child.classList.remove("active");
      }

      this.classList.add("active");
      activeCount++;

      //Get link for results button
      var useLink = document.getElementsByClassName("use-link")[0];
      resultLink.stopUpdating = useLink.classList.contains("active")
        ? true
        : false;

      var anchor = this.getElementsByTagName("a");
      if (anchor.length > 0) {
        if (!resultLink.stopUpdating) {
          resultLink.linkURL = anchor[0].href;
        } else {
          var el = useLink.getElementsByTagName("a");
          resultLink.linkURL = el[0].href;
        }
      }

      //Activate results button
      if (qRows.length == activeCount) {
        resultsBtn.classList.remove("disabled");
        var anchor = resultsBtn.getElementsByTagName("a");
        anchor[0].href = resultLink.linkURL;
      }
    });
  }
}

var maxHeight = 0;
var li = document.querySelectorAll(".grid:not(.no-isotope) .grid-item");
li.forEach(function (element, index) {
  var thisH = element.offsetHeight;
  if (thisH > maxHeight) {
    maxHeight = thisH;
  }
});

li.forEach(function (element, index) {
  element.style.height = maxHeight + "px";
});

var buttons = document.querySelectorAll(".weekday-filter");
var counsellors = document.querySelector(".grid:not(.no-isotope)");
var iso;

if (counsellors) {
  iso = new Isotope(counsellors, {
    layoutMode: "fitRows",
    itemSelector: ".grid-item",
    fitRows: {
      gutter: 30,
    },
  });
}

//Counsellors - filter by availability
var filterArr = [];
var allBtn = document.querySelector(".active");
function reset_values() {
  const ulElement = document.querySelector("ul.counsellors-list.grid.Active");
  if (ulElement) {
    ulElement.classList.remove("Active");
  }

  const liElements = document.querySelectorAll(
    ".wp-block-post.counsellors.grid-item.next-available"
  );
  const headingElement = document.querySelector(".avialable-heading");
  if (headingElement) {
    headingElement.remove();
  }
  liElements.forEach((liElement) => {
    const specialisationsElement = liElement.querySelector(".specialisations");
    const availableDiv = liElement.querySelector(".available");
    const availableDiv1 = liElement.querySelector(".heading");
    specialisationsElement.style.display = "block";
    if (availableDiv && availableDiv1) {
      availableDiv.remove();
      availableDiv1.remove();
    }
  });
}
if (buttons.length > 0) {
  for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", function (e) {
      e.preventDefault();

      var selectedVal = this.getAttribute("data-filter");

      if (selectedVal == ".all-days" || selectedVal == ".next-available") {
        filterArr = [];
        if (selectedVal == ".next-available") {
          this.classList.add("active");
        }
      } else {
        if (this.classList.contains("active")) {
          var index = filterArr.indexOf(selectedVal);
          if (index !== -1) {
            filterArr.splice(index, 1);
          }
          this.classList.remove("active");
        } else {
          filterArr.push(selectedVal);
          this.classList.add("active");
        }
      }

      const next = document.querySelectorAll('[data-filter=".next-available"]');

      if (filterArr.length > 0) {
        allBtn.classList.remove("active");
        for (var j = 0; j < next.length; j++) {
          next[j].classList.remove("active");
        }
      } else {
        var activeBtn = document.querySelectorAll("span.active");
        for (var j = 0; j < activeBtn.length; j++) {
          activeBtn[j].classList.remove("active");
        }

        if (selectedVal == ".next-available") {
          this.classList.add("active");
        } else {
          allBtn.classList.add("active");
        }
      }

      //Get data for next available counsellors from API
      if (selectedVal == ".next-available") {
        const loaderselector = document.querySelector(".next-loader");
        if (loaderselector) {
          loaderselector.remove();
        }
        var iconElement = document.createElement("i");
        iconElement.classList.add("next-loader");
        iconElement.classList.add("fa");
        iconElement.classList.add("fa-spin");
        iconElement.classList.add("fa-spinner");

        var spanElement = document.querySelector(".btn.weekday-filter.active");
        spanElement.insertBefore(iconElement, spanElement.firstChild);
        iconElement.innerHTML = ` `;

        getData(
          "https://au.cf.tacklit.com/v1/clinicians/nextAvailabilities"
        ).then((data) => {
          const loaderselector = document.querySelector(".next-loader");
          loaderselector.remove();
          data.filter(
            (record) =>
              record?.nextAvailabilities && record?.caseLoad?.isOpenToNewClients
          );

          // console.log("nextAvailabilities", data);

          const liElements = document.querySelectorAll(
            ".counsellors-list li[data-id]"
          );
          const dataIdArray = Array.from(liElements).map((li) =>
            li.getAttribute("data-id")
          );

          // console.log("dataIdArray", dataIdArray);

          const matchedIds = Object.values(data)
            .filter((obj) => dataIdArray.includes(obj._id))
            .filter(
              (obj) =>
                obj.nextAvailabilities &&
                obj.caseLoad.isOpenToNewClients &&
                obj.name !== "Client Services Team"
            )
            .filter((obj) =>
              obj.nextAvailabilities.some(
                (availability) => availability.availabilities.length > 0
              )
            )
            .filter((obj) =>
              obj.nextAvailabilities.some((availability) =>
                availability.appointmentTypeName.includes("Initial Consult")
              )
            )
            .sort((a, b) => {
              const dateA = new Date(
                a.nextAvailabilities[0]?.availabilities[0]?.date
              );
              const dateB = new Date(
                b.nextAvailabilities[0]?.availabilities[0]?.date
              );
              return dateA - dateB;
            });
          function formatDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate();
            let suffix = "th";

            if (day === 1 || day === 21 || day === 31) {
              suffix = "st";
            } else if (day === 2 || day === 22) {
              suffix = "nd";
            } else if (day === 3 || day === 23) {
              suffix = "rd";
            }

            const month = date.toLocaleString("en-US", { month: "long" });

            return `${day}${suffix} ${month}`;
          }
          const existingheadingDiv =
            document.querySelector(".avialable-heading");
          if (existingheadingDiv) {
            existingheadingDiv.remove();
          }

          // console.log("matchedIds", matchedIds);

          matchedIds.slice(0, 5).forEach((obj, index) => {
            const liElement = document.querySelector(
              `.counsellors-list li[data-id="${obj._id}"]`
            );
            if (liElement) {
              liElement.classList.add("next-available", `class-${index + 1}`);
              liElement.style.order = index + 1;

              const parentElement = liElement.parentElement;
              parentElement.style.display = "flex";
              parentElement.classList.add("Active");
              const existingavailableDiv =
                liElement.querySelector(".available");
              const existingavailableHead = liElement.querySelector(".heading");
              if (existingavailableDiv && existingavailableHead) {
                existingavailableDiv.remove();
                existingavailableHead.remove();
              }

              const divElement = document.createElement("div");
              const divElement1 = document.createElement("div");
              divElement.classList.add("available");
              divElement1.classList.add("heading");

              const specialisationsElement =
                liElement.querySelector(".specialisations");
              const rebatesElement = liElement.querySelector(".rebates");
              if (rebatesElement) {
                rebatesElement.parentNode.insertBefore(
                  divElement,
                  rebatesElement.nextSibling
                );
                rebatesElement.parentNode.insertBefore(
                  divElement1,
                  rebatesElement.nextSibling
                );
              } else {
                divElement1.classList.add("norebaElement");
                specialisationsElement.parentNode.insertBefore(
                  divElement,
                  specialisationsElement.nextSibling
                );
                specialisationsElement.parentNode.insertBefore(
                  divElement1,
                  specialisationsElement.nextSibling
                );
              }

              specialisationsElement.style.display = "none";
              const day = obj.nextAvailabilities[0]?.availabilities[0]?.day;
              const date = obj.nextAvailabilities[0]?.availabilities[0]?.date;
              const timeslot = obj.nextAvailabilities
                .filter((availability) =>
                  availability.appointmentTypeName.includes("Initial Consult")
                )
                .flatMap(
                  (availability) =>
                    availability.availabilities[0]?.timeSlots || []
                );
              const modifiedTimeslot = timeslot.length;
              const formatdate = formatDate(date);
              const month = new Date(date).toLocaleString("en-US", {
                month: "short",
              });
              const appointmentday = new Date(date).getDate();
              divElement.innerHTML = `<span style="background-image:url('https://i.ibb.co/K9098pz/calendar.png')"><p class='appointmentday'>${appointmentday}</p><p class='appointmentmonth'>${month}</p></span><p>${day} ${formatdate}<br><span>${modifiedTimeslot} Open Appointments  </span></p>`;
              divElement1.innerHTML = `<span>Next Available:</span>`;
            }
          });
          const divElement2 = document.createElement("div");
          divElement2.classList.add("avialable-heading");
          const headingSelector = document.querySelector("#waiting-list");
          headingSelector.parentNode.insertBefore(
            divElement2,
            headingSelector.nextSibling
          );
          const maxLength = 5;
          const count = Math.min(matchedIds.length, maxLength);
          const message = `Showing next ${count} available counsellors`;
          divElement2.innerHTML = message;
          setTimeout(() => {
            iso.arrange({ filter: ".next-available" });
          }, 100);
        });
      }
      if (selectedVal == ".all-days") {
        reset_values();
        iso.arrange({ filter: filterArr.join(", ") });
      }
      if (filterArr.length > 0) {
        reset_values();
        iso.arrange({ filter: filterArr.join(", ") });
      }
    });
  }
}

async function getData(url = "") {
  const response = await fetch(url, {
    method: "GET",
    // mode: "no-cors", // no-cors, *cors, same-origin
    headers: {
      access_token: "A3A25B7AD27A4EB569A6C9BEEF7E5",
      // "Content-Type": "application/json",
    },
  });
  return response.json();
}

//Popup for services page
var modals = document.querySelectorAll(".service-card");

modals.forEach((element) => {
  //Add click listeners to open-modal buttons
  element.addEventListener("click", () => {
    //Get the unique popup modal for that button
    var popupModal = document.getElementById(element.dataset.popupTrigger);

    //Select the close button of current popup modal
    var popupModalCloseButton = document
      .getElementById(element.dataset.popupTrigger)
      .getElementsByClassName("modal-close-button")[0];

    // Show/hide modal on click by toggling the class
    popupModal.classList.toggle("show-modal");

    //Add event listener to close button on popup modal.
    popupModalCloseButton.addEventListener("click", () => {
      popupModal.classList.remove("show-modal");
    });
  });
});

// Popover for accredited service provider
document.addEventListener("DOMContentLoaded", () => {
  // Show popover on mobile-text click
  document.querySelectorAll(".image-container .mobile-text").forEach((element) => {
    element.addEventListener("click", (e) => {
      e.stopPropagation();
      const container = element.closest(".image-container");
      if (container) {
        const popover = container.querySelector(".popover");
        if (popover) popover.style.display = "block";
      }
    });
  });

  // Show popover on image hover
  document.querySelectorAll(".image-container .image").forEach((element) => {
    element.addEventListener("mouseover", () => {
      const container = element.closest(".image-container");
      if (container) {
        const popover = container.querySelector(".popover");
        if (popover) popover.style.display = "block";
      }
    });
  });

  // Hide popover on mouseleave
  document.querySelectorAll(".image-container").forEach((container) => {
    container.addEventListener("mouseleave", () => {
      const popover = container.querySelector(".popover");
      if (popover) popover.style.display = "none";
    });
  });

  // Hide all popovers on document click
  document.addEventListener("click", () => {
    document.querySelectorAll(".image-container .popover").forEach((popover) => {
      popover.style.display = "none";
    });
  });

  // Prevent popover click from closing itself
  document.querySelectorAll(".image-container .popover").forEach((popover) => {
    popover.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });

  // Add container-wrapper class to parent .container
  document.querySelectorAll(".image-container").forEach((container) => {
    const parentContainer = container.closest(".container");
    if (parentContainer) {
      parentContainer.classList.add("container-wrapper");
    }
  });
});
